import { HttpHeaders } from '@angular/common/http';
import { BsDatepickerConfig } from 'ngx-bootstrap';

export class AppConstant {

  public static datePickrConfig = {
    isAnimated: true,
    adaptivePosition: true,
    showWeekNumbers: false,
    dateInputFormat: 'DD MMM, YYYY'
  };

  public static packageList = [
  {
    id: '92012a04-1514-4401-a430-a2a2f017ed6d',
    name: 'Bookkeeping, Financial Statements & Director\'s Report',
    description: 'Obtaining a business understanding and an understanding of the business environment in which it operates in allows the accountant to define the significant accounting policies disclosure in the financial statements and to provide the appropriate treatment for the various transactions',
    projectTypeId: '12378993-6482-47d1-946e-2fd201b426c4',
    outcome: 'Understanding Business Form, Bank Statements and Documents, Year-end Journal Adjustments, General Ledger and Trial Balance, Director\'s Report, Financial Statements',
    duration: 23,
    durationType: {
      id: 1,
      name: 'Days'
    },
    startDate: '23 Jan, 2020',
    endDate: '24 Mar, 2020',
    markets: [
      {
        accountType: 'Market',
        name: 'India',
        queryType: 'state',
        type: 'market',
        id: '1'
      },
      {
        accountType: 'Market',
        name: 'Singapore',
        queryType: 'state',
        type: 'market',
        id: '3'
      }
    ],
    packageType: 'pending',
    status: 'package',
    cost: 1000,
    createdBy: 'Admin',
    createdAt: '2020-01-10T05:37:12.962Z',
    mainRunningCode: 'PS-1087',
    milestones:[
      {
        title: 'Sending "Understanding Business Form"'
      },
      {
        title: 'Requesting bank statements and documents'
      },
      {
        title: 'Sending year-end journal adjustment entries'
      },
      {
        title: 'Sending the General Ledger and Trial Balance'
      },
      {
        title: 'Sending the Director\'s Report'
      },
      {
        title: 'Sending the Financial Statements'
      }
    ],
    serviceProvider:[{
      id: '9f04ddd0-44ee-4736-ab9e-021b77bc8601',
      projectId: '36259e1c-dccb-4a65-ae23-83f16368580c',
      status: 'package',
      serviceProviderId: '363f310b-1eb3-40a9-a963-4545de9251f4',
      createdAt: '2020-01-10T05:37:13.907Z',
      createdBy:null,
      subRunningCode: '1018',
      spDetail:{
        id: '363f310b-1eb3-40a9-a963-4545de9251f4',
        displayName: 'verasa Tsfa',
        profileUrl: 'https://ebs-dev-assets.s3.ap-southeast-1.amazonaws.com/10087cd9-ef54-4b4f-81ff-d923d8990937'
      }
    }],
    createdUser:{
      id: 'ced645cd-5398-4a1a-82dc-b868d93d8a72',
      displayName: 'Ravibvhv',
      profileUrl: 'https://ebs-dev-assets.s3.ap-southeast-1.amazonaws.com/47a4d78b-4696-4d86-a134-2fef4a98b26d',
      code: 'client'
    },
    clients:[],
    serviceOffering:[
      {
        id: "d31c6465-066c-4517-b244-fb59e85ce47f",
        name: "IP (Trademark and Copyright Registration Patent Filing)"
      },
      {
        id: "2aeb3ef0-05d1-4032-91c6-d5ad63ceb10e",
        name: "Employment and ESOP's"
      }
    ]
  },
  {
    id: '36259e1c-dccb-4a65-ae23-83f1636858',
    name: 'Annual Compliance Management',
    projectTypeId: '12378993-6482-47d1-946e-2fd201b426c4',
    description: 'Obtaining a business understanding and an understanding of the business environment in which it operates in allows the accountant to define the significant accounting policies disclosure in the financial statements and to provide the appropriate treatment for the various transactions',
    duration: 23,
    durationType: {
      id: 2,
      name: 'Hours'
    },
    outcome: 'AGM Document, ACRA Annual Filing Acknowledgement',
    startDate: '23 Jan, 2020',
    endDate: '24 Mar, 2020',
    markets: [
      {
        accountType: 'Market',
        name: 'India',
        queryType: 'state',
        type: 'market',
        id: '1'
      },
      {
        accountType: 'Market',
        name: 'Australia',
        queryType: 'state',
        type: 'market',
        id: '2'
      }
    ],
    packageType: 'pending',
    status: 'bid',
    cost: 3000,
    createdBy: 'You',
    createdAt: '2020-01-10T05:37:12.962Z',
    mainRunningCode: 'PS-1087',
    milestones:[
      {
        title: 'Filing AGM'
      },
      {
        title: 'ACRA Filing'
      }
    ],
    serviceProvider:[{
      id: '9f04ddd0-44ee-4736-ab9e-021b77bc8601',
      projectId: '36259e1c-dccb-4a65-ae23-83f16368580c',
      status: 'bid',
      serviceProviderId: '363f310b-1eb3-40a9-a963-4545de9251f4',
      createdAt: '2020-01-10T05:37:13.907Z',
      createdBy:null,
      subRunningCode: '1018',
      spDetail:{
        id: '363f310b-1eb3-40a9-a963-4545de9251f4',
        displayName: 'verasa Tsfa',
        profileUrl: 'https://ebs-dev-assets.s3.ap-southeast-1.amazonaws.com/10087cd9-ef54-4b4f-81ff-d923d8990937'
      }
    }],
    createdUser:{
      id: 'ced645cd-5398-4a1a-82dc-b868d93d8a72',
      displayName: 'Ravibvhv',
      profileUrl: 'https://ebs-dev-assets.s3.ap-southeast-1.amazonaws.com/47a4d78b-4696-4d86-a134-2fef4a98b26d',
      code: 'client'
    },
    clients:[],
    serviceOffering:[
      {
        id: "d31c6465-066c-4517-b244-fb59e85ce47f",
        name: "IP (Trademark and Copyright Registration Patent Filing)"
      },
      {
        id: "2aeb3ef0-05d1-4032-91c6-d5ad63ceb10e",
        name: "Employment and ESOP's"
      }
    ]
  },
  {
    id: '36259e1c-dccb-4a65-ae23-83f368580c',
    name: 'Company Incorporation',
    projectTypeId: '12378993-6482-47d1-946e-2fd201b426c4',
    description: 'Obtaining a business understanding and an understanding of the business environment in which it operates in allows the accountant to define the significant accounting policies disclosure in the financial statements and to provide the appropriate treatment for the various transactions',
    outcome: 'BizFile',
    duration: 7,
    durationType: {
      id: 1,
      name: 'Days'
    },
    startDate: '23 Jan, 2020',
    endDate: '24 Mar, 2020',
    markets: [
      {
        accountType: 'Market',
        name: 'Australia',
        queryType: 'state',
        type: 'market',
        id: '2'
      },
      {
        accountType: 'Market',
        name: 'Singapore',
        queryType: 'state',
        type: 'market',
        id: '3'
      },
    ],
    packageType: 'pending',
    status: 'bid',
    cost: 2000,
    createdBy: 'You',
    createdAt: '2020-01-10T05:37:12.962Z',
    mainRunningCode: 'PS-1087',
    milestones:[
      {
        title: 'Sending company information'
      },
      {
        title: 'KYC Documentation'
      },
      {
        title: 'ACRA filing'
      }
    ],
    serviceProvider:[{
      id: '9f04ddd0-44ee-4736-ab9e-021b77bc8601',
      projectId: '36259e1c-dccb-4a65-ae23-83f16368580c',
      status: 'bid',
      serviceProviderId: '363f310b-1eb3-40a9-a963-4545de9251f4',
      createdAt: '2020-01-10T05:37:13.907Z',
      createdBy:null,
      subRunningCode: '1018',
      spDetail:{
        id: '363f310b-1eb3-40a9-a963-4545de9251f4',
        displayName: 'verasa Tsfa',
        profileUrl: 'https://ebs-dev-assets.s3.ap-southeast-1.amazonaws.com/10087cd9-ef54-4b4f-81ff-d923d8990937'
      }
    }],
    createdUser:{
      id: 'ced645cd-5398-4a1a-82dc-b868d93d8a72',
      displayName: 'Ravibvhv',
      profileUrl: 'https://ebs-dev-assets.s3.ap-southeast-1.amazonaws.com/47a4d78b-4696-4d86-a134-2fef4a98b26d',
      code: 'client'
    },
    clients:[],
    serviceOffering:[
      {
        id: "d31c6465-066c-4517-b244-fb59e85ce47f",
        name: "IP (Trademark and Copyright Registration Patent Filing)"
      },
      {
        id: "2aeb3ef0-05d1-4032-91c6-d5ad63ceb10e",
        name: "Employment and ESOP's"
      }
    ]
  },
  {
    id: '36259e1c-dccb-4a65-ae23-83f163680c',
    name: 'Employee Agreement',
    projectTypeId: '12378993-6482-47d1-946e-2fd201b426c4',
    description: 'Obtaining a business understanding and an understanding of the business environment in which it operates in allows the accountant to define the significant accounting policies disclosure in the financial statements and to provide the appropriate treatment for the various transactions',
    outcome: 'Employment Agreement',
    duration: 23,
    durationType: {
      id: 2,
      name: 'Hours'
    },
    startDate: '23 Jan, 2020',
    endDate: '24 Mar, 2020',
    markets: [
      {
        accountType: 'Market',
        name: 'India',
        queryType: 'state',
        type: 'market',
        id: '1'
      },
      {
        accountType: 'Market',
        name: 'Singapore',
        queryType: 'state',
        type: 'market',
        id: '3'
      },
    ],
    packageType: 'pending',
    status: 'bid',
    cost: 1000,
    createdBy: 'Admin',
    createdAt: '2020-01-10T05:37:12.962Z',
    mainRunningCode: 'PS-1087',
    milestones:[
      {
        title: 'Inputs for employment agreement'
      },
      {
        title: 'Sending draft Employment agreement'
      },
      {
        title: 'Sending final copy of employment agreement'
      }
    ],
    serviceProvider:[{
      id: '9f04ddd0-44ee-4736-ab9e-021b77bc8601',
      projectId: '36259e1c-dccb-4a65-ae23-83f16368580c',
      status: 'package',
      serviceProviderId: '363f310b-1eb3-40a9-a963-4545de9251f4',
      createdAt: '2020-01-10T05:37:13.907Z',
      createdBy:null,
      subRunningCode: '1018',
      spDetail:{
        id: '363f310b-1eb3-40a9-a963-4545de9251f4',
        displayName: 'verasa Tsfa',
        profileUrl: 'https://ebs-dev-assets.s3.ap-southeast-1.amazonaws.com/10087cd9-ef54-4b4f-81ff-d923d8990937'
      }
    }],
    createdUser:{
      id: 'ced645cd-5398-4a1a-82dc-b868d93d8a72',
      displayName: 'Ravibvhv',
      profileUrl: 'https://ebs-dev-assets.s3.ap-southeast-1.amazonaws.com/47a4d78b-4696-4d86-a134-2fef4a98b26d',
      code: 'client'
    },
    clients:[],
    serviceOffering:[
      {
        id: "d31c6465-066c-4517-b244-fb59e85ce47f",
        name: "IP (Trademark and Copyright Registration Patent Filing)"
      },
      {
        id: "2aeb3ef0-05d1-4032-91c6-d5ad63ceb10e",
        name: "Employment and ESOP's"
      }
    ]
  }];
  public static dateFormat = 'DD MMM, YYYY';
  public static pipeDateFormat = 'dd MMM, yyy';
  public static noPackageMsg = {
    noBid: 'No bids found',
    noPackage: 'No package found'
  };

  public static topRatedService = [
    {
      image: '',
      price: '',
      job: 'aaa',
      location: '',
      rating: '',
      services: []
    },
    {
      image: '',
      price: '',
      job: 'bbb',
      location: '',
      rating: '',
      services: []
    },
    {
      image: '',
      price: '',
      job: 'ccc',
      location: '',
      rating: '',
      services: []
    },
    {
      image: '',
      price: '',
      job: 'dd',
      location: '',
      rating: '',
      services: []
    }
  ];

  public static accounts = {
    sp: 'tech_analyst',
    pk: 'package'
  };

  public static spProfile = {
    publishedReportsSkip: 0,
    publishedReportsLimit: 5,
    upcomingReportSkip: 0,
    upcomingReportLimit: 5
  };

  public static dateSort = {
    dateSortDESC : 'updated_at DESC',
    dateSortASC: 'updated_at ASC',
    dateSortUpcomingDESC: 'scheduled_date DESC',
    dateSortUpcomingASC: 'scheduled_date ASC'
  };

  public static followLawyersLimit = 5;

  public static reportInputBoxPlaceholder = 'Please enter your message';

  public static reportLimit = 7;

  public static requiredField = 'This field is required';

  public static socialFeedsCarouselLimit = 5;

  public static trendingUpdatesLimit = 4;

  public static requestForQuotes = [
    {
      from: 'Anna',
      dueStatus: 'Overdue',
      dueDate: '02/12/2019'
    },
    {
      from: 'John',
      dueStatus: 'Not Overdue',
      dueDate: '02/12/2019'
    },
    {
      from: 'Sam',
      dueStatus: 'Not Overdue',
      dueDate: '02/12/2019'
    },
    {
      from: 'Sam',
      dueStatus: 'Overdue',
      dueDate: '02/12/2019'
    },
    {
      from: 'Alec',
      dueStatus: 'Not Overdue',
      dueDate: '02/12/2019'
    },
    {
      from: 'Felix',
      dueStatus: 'Not Overdue',
      dueDate: '02/12/2019'
    },
    {
      from: 'John',
      dueStatus: 'Not Overdue',
      dueDate: '02/12/2019'
    }
  ];

  public static projectUpdates = [
    {
      updateName: 'John Doe',
      middleText: 'uploaded document to project',
      updatedProject: 'Speridia',
      dueOn: ''
    },
    {
      updateName: 'Audit',
      middleText: '- DTT is due on',
      updatedProject: '',
      dueOn: '08/11/2019'
    },
    {
      updateName: 'John Doe',
      middleText: 'uploaded document to project',
      updatedProject: 'Speridia',
      dueOn: ''
    },
    {
      updateName: 'Anne',
      middleText: 'closed document to project',
      updatedProject: 'Speridia',
      dueOn: ''
    },
    {
      updateName: 'Anne',
      middleText: 'uploaded document to',
      updatedProject: 'IP Registration',
      dueOn: ''
    },
    {
      updateName: 'Anne',
      middleText: 'uploaded document to project',
      updatedProject: 'Company Trademark',
      dueOn: ''
    },
    {
      updateName: 'John Doe',
      middleText: 'uploaded document to',
      updatedProject: 'project Speridia',
      dueOn: ''
    },
  ];

  public static allReportsPagination = {
    reports: [
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Published'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Ready to Publish'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Under Review'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Under Review'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Published'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Draft'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Published'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Published'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Published'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Published'
      },
      {
        title: 'Service Without Limitations',
        submittedDate: '23 Mar 2019',
        lastUpdatedDate: '23 Mar 2019',
        lastUpdatedUser: '',
        status: 'Published'
      }
    ],
    initialPage: 1,
    maxSize: 4
  };

  public static reportCategory = [
    {
      label: 'Law',
      value: { id: 1, name: 'Law' }
    },
    {
      label: 'Tax',
      value: { id: 2, name: 'Tax' }
    },
    {
      label: 'Secreterial',
      value: { id: 3, name: 'Secreterial' }
    }
  ];

  public static myReportSortOptions = [
    {
      label: 'Date: New to Old',
      value: { id: 1, name: 'Date: New to Old' }
    },
    {
      label: 'Date: Old to New',
      value: { id: 2, name: 'Date: Old to New' }
    }
  ];

  public static reportSortOptions = [
    {
      label: 'View all',
      value: { id: 1, name: 'view_all' }
    },
    {
      label: 'Draft',
      value: { id: 2, name: 'draft' }
    },
    {
      label: 'Published',
      value: { id: 3, name: 'published' }
    },
    {
      label: 'Under Review',
      value: { id: 4, name: 'under_review' }
    },
    {
      label: 'Review Failed',
      value: { id: 5, name: 'review_failed' }
    },
    {
      label: 'Ready to Publish',
      value: { id: 6, name: 'ready_to_publish' }
    }
  ];

  public static myReportFilterOptions = [
    {
      label: 'Filter',
      value: { id: 0, name: 'Default' }
    },
    {
      label: 'Law',
      value: { id: 1, name: 'Law' }
    },
    {
      label: 'Tax',
      value: { id: 2, name: 'Tax' }
    },
    {
      label: 'Secreterial',
      value: { id: 3, name: 'Secreterial' }
    }
  ];

  public static reportStatus = {
    draft: 'draft',
    underReview: 'under_review',
    readyToPublish: 'ready_to_publish',
    reviewFailed: 'review_failed',
    published: 'published'
  };

  public static reportFilterOptions = [
    {
      label: 'Law',
      value: { id: 1, name: 'Law' }
    },
    {
      label: 'Tax',
      value: { id: 2, name: 'Tax' }
    },
    {
      label: 'Secreterial',
      value: { id: 3, name: 'Secreterial' }
    }
  ];

  public static reports = [
    {
      title: 'Agritech : Technology Helping New Zealand to Produce More with Less',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero odio, ut congue nisi lobortis vel adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero cerfwerfwe rferferferf adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero odio, ut congue nisi lobortis vel adipiscing elit. Donec dapibus turpis adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero odio, ut congue nisi lobortis vel adipiscing elit. Donec dapibus turpis',
      publishDate: '14 June 2019',
      publisherName: 'James Smith',
      publisherPosition: 'Lawyer',
      rating: 4.6,
      likes: 5,
      comments: 8,
      priceRate: null
    },
    {
      title: 'Agritech : Technology Helping New Zealand to Produce More with Less',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero odio, ut congue nisi lobortis vel adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero cerfwerfwe rferferferf adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero odio, ut congue nisi lobortis vel adipiscing elit. Donec dapibus turpis adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero odio, ut congue nisi lobortis vel adipiscing elit. Donec dapibus turpis',
      publishDate: '14 June 2019',
      publisherName: 'James Smith',
      publisherPosition: 'Lawyer',
      rating: 4.6,
      likes: 5,
      comments: 8,
      priceRate: 20
    },
    {
      title: 'Agritech : Technology Helping New Zealand to Produce More with Less',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero odio, ut congue nisi lobortis vel adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero cerfwerfwe rferferferf adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero odio, ut congue nisi lobortis vel adipiscing elit. Donec dapibus turpis adipiscing elit. Donec dapibus turpis eget lobortis euismod. Nunc aliquet libero odio, ut congue nisi lobortis vel adipiscing elit. Donec dapibus turpis',
      publishDate: '14 June 2019',
      publisherName: 'James Smith',
      publisherPosition: 'Lawyer',
      rating: 4.6,
      likes: 5,
      comments: 8,
      priceRate: 500
    }
  ];

  public static followersLimit = 10;

  public static limit = 10;

  public static highlightLimit = 4;

  public static blogLimit = 4;

  public static socialFeedLimit = 4;

  public static workHoursConstants = {
    startTime: '00:00',
    endTime: '23:59',
    defaultStartTime: '09:00:00+00',
    defaultEndTime: '18:00:00+00',
    milliSeconds: '+00',
    interval: 30
  };

  public static createPackage = {
    durationTypes : [
      {
        id: 'hours',
        name: 'Hour(s)'
      },
      {
        id: 'day',
        name: 'Day(s)'
      },
      {
        id: 'week',
        name: 'Week(s)'
      },
      {
        id: 'month',
        name: 'Month(s)'
      }
    ]
  };

  public static packages = [
    {
      company: '',
      packageName: '',
      price: '',
      location: '',
      rating: '',
      services: [],
      reviews: 10
    },
    {
      company: '',
      packageName: '',
      price: '',
      location: '',
      rating: '',
      services: [],
      reviews: 10
    },
    {
      company: '',
      packageName: '',
      price: '',
      location: '',
      rating: '',
      services: [],
      reviews: 10
    },
    {
      company: '',
      packageName: '',
      price: '',
      location: '',
      rating: '',
      services: [],
      reviews: 10
    }
  ];

  public static trendingList = [
    {
      image: '',
      title: '',
      description: '',
      author: '',
      publishedOn: '',
      rate: []
    },
    {
      image: '',
      title: '',
      description: '',
      author: '',
      publishedOn: '',
      rate: []
    },
    {
      image: '',
      title: '',
      description: '',
      author: '',
      publishedOn: '',
      rate: []
    },
    {
      image: '',
      title: '',
      description: '',
      author: '',
      publishedOn: '',
      rate: []
    }
  ];

 /*  home data change */
   public static  appInitContent = {
      spHomeLimit: 4,
      packageHomeLimit: 3,
      trendingHomeLimit: 3,
      signInBtn: 'Sign In',
      createProjectBtn: 'Create Project',
      searchPH: 'Search By',
      searchPHServices: 'Services',
      searchPHMarkets: 'Markets',
      searchPHSPName: 'Services Provider\'s Name',
      searchPHOr: 'or',
      searchBtn: 'Search',
      joinOurSP: 'Come and join our service provider team.',
      requestToJoin: 'Request to Join',
      signInPriceHover: 'Sign In to view the rate',
      serviceOffered: 'Service offered',
      view: 'View',
      viewAll: 'View All',
      newsletterTitle: 'Subscribe to Our Newsletter',
      newsletterContent: 'Join our subscribers list to get the latest news and updates delivered directly in your inbox.',
      subscribeBtn: 'Subscribe',
      aboutUs: 'About Us',
      media: 'Media',
      contactUs: 'Contact Us',
      support: 'Support',
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      connectUs: 'Connect with us on',
      copyright: 'Copyright @ ',
      goTop: 'Go to top',
      // footerTitle: 'Download the Mobile App',
      // trendingUpdates: 'Trending Updates'
    };
    public static appContentData = {
      contentValues: {
        bannerTitle: 'Search for services and providers',
        bannerImage: 'https://ebs-dev-assets.s3-ap-southeast-1.amazonaws.com/base-assets/banner_image.png'
      },
      serviceType: [
        {
          id: '2aeb3ef0-05d1-4032-91c6-d5ad63ceb10e',
          name: 'Law',
          type: 'value',
          value: '',
          serviceTypeLine: [
            {
              id: '0a1e528b-d782-466b-a0cd-baef0e4dd73e',
              name: 'IP (Trademark and Copyright Registration, Patent Filing)',
              serviceTypeId: '2aeb3ef0-05d1-4032-91c6-d5ad63ceb10e'
            },
            {
              id: '0a21bdaa-d6a2-4a64-9140-458cc83ec4b4',
              name: 'Real Estate',
              serviceTypeId: '2aeb3ef0-05d1-4032-91c6-d5ad63ceb10e'
            },
            {
              id: '4fa425a1-8ffd-4c12-8038-fe95d63778ef',
              name: 'Early Stage or StartUps and Fund Raising',
              serviceTypeId: '2aeb3ef0-05d1-4032-91c6-d5ad63ceb10e'
            },
            {
              id: 'ff31330b-438c-4508-ab39-d5af3f69669c',
              name: 'Employment and ESOP\'s',
              serviceTypeId: '2aeb3ef0-05d1-4032-91c6-d5ad63ceb10e'
            }
          ]
        },
        {
          id: 'a4d6c088-6608-4759-86e1-af3a6b748df7',
          name: 'Tax',
          type: 'value',
          value: '',
          serviceTypeLine: [
            {
              id: '4b9e2f82-a30c-4f2d-88c4-a1e7fb22d488',
              name: 'Tax Structuring and Advise',
              serviceTypeId: 'a4d6c088-6608-4759-86e1-af3a6b748df7'
            },
            {
              id: '66ebd51f-0c89-447e-9ee1-f8eb6a0c8fd6',
              name: 'Payroll Management',
              serviceTypeId: 'a4d6c088-6608-4759-86e1-af3a6b748df7'
            },
            {
              id: '89016af4-4bcf-428b-9872-89949bd367ef',
              name: 'Tax Filing and Compliance',
              serviceTypeId: 'a4d6c088-6608-4759-86e1-af3a6b748df7'
            },
            {
              id: '95a6b555-e62a-4f70-9612-94f97aba3bf6',
              name: 'Audit and Assurance',
              serviceTypeId: 'a4d6c088-6608-4759-86e1-af3a6b748df7'
            },
            {
              id: 'd6add839-bc14-4787-bab1-0b85e869fd91',
              name: 'Accounting and Book Keeping',
              serviceTypeId: 'a4d6c088-6608-4759-86e1-af3a6b748df7'
            }
          ]
        },
        {
          id: 'd31c6465-066c-4517-b244-fb59e85ce47f',
          name: 'Secretarial',
          type: 'value',
          value: '',
          serviceTypeLine: [
            {
              id: '69597a64-8885-4a09-86ea-d237ae1f9c55',
              name: 'Immigration',
              serviceTypeId: 'd31c6465-066c-4517-b244-fb59e85ce47f'
            },
            {
              id: 'a6c24ccd-e8ce-4fa0-83be-229e7de6801a',
              name: 'Nominee Services',
              serviceTypeId: 'd31c6465-066c-4517-b244-fb59e85ce47f'
            },
            {
              id: 'ad8c7c94-688c-4f78-88b9-061fd892fccd',
              name: 'Corporate Secretarial, Annual Returns and Filing',
              serviceTypeId: 'd31c6465-066c-4517-b244-fb59e85ce47f'
            },
            {
              id: 'eb0fa469-45ef-4c7d-9560-9fa9eeae7512',
              name: 'Company Formation',
              serviceTypeId: 'd31c6465-066c-4517-b244-fb59e85ce47f'
            }
          ]
        },
        {
          id: '103205be-291c-4c15-b0cf-a22df39dc611',
          name: 'Tech',
          type: 'url',
          value: 'http://admin-dev.ecosystm.perfomatix.online',
          serviceTypeLine: []
        }
      ],
      hodwItWorks: [
        {
          title: 'Trusted Selection of Service Providers',
          description: 'Select your service providers based on the feedback and satisfaction of your peer community.',
          iconUrl: 'https://ebs-dev-assets.s3-ap-southeast-1.amazonaws.com/how-it-works/trusted_services.png'
        },
        {
          title: 'Create Projects',
          description: 'Create your own projects and ask service providers to quote their services towards your requirements.',
          iconUrl: 'https://ebs-dev-assets.s3-ap-southeast-1.amazonaws.com/how-it-works/create_project.png'
        },
        {
          title: 'Convenient and Secured Payment Process',
          // tslint:disable-next-line: max-line-length
          description: 'Select from a variety of payment options and enjoy the peace of mind that your service provider will only receive the payment once you are satisfied with the service delivery.',
          iconUrl: 'https://ebs-dev-assets.s3-ap-southeast-1.amazonaws.com/how-it-works/payment.png'
        },
        {
          title: 'Collaborate Easily With Service Providers',
          // tslint:disable-next-line: max-line-length
          description: 'Leverage on our extensive portfolio of collaboration tools to ensure a secure and fully auditable engagement with your service providers.',
          iconUrl: 'https://ebs-dev-assets.s3-ap-southeast-1.amazonaws.com/how-it-works/collaboration.png'
        }
      ]
    };
    public static homeSearchData = [
      {
        text: 'Real Estate',
        type: 'Service',
        subData: [

        ]
      },
       {
        text: 'Tax Structuring and Advise',
        type: 'Service',
        subData: [

        ]
      },
       {
        text: 'Payroll Management',
        type: 'Service',
        subData: [

        ]
      },
      {
        text: 'IP (Trademark and Copyright Registration, Patent Filing)',
        type: 'Service',
        subData: [
          {
            text: 'India',
            type: 'Markets'
          }
        ]
      },
        {
        text: 'Employment and ESOP\'s',
        type: 'Service',
        subData: [
          {
            text: 'Singapore',
            type: 'Markets'
          }
        ]
      },
      {
        text: 'Arun',
        type: 'Service Provider'
      },
      {
        text: 'Nandhu Legal Services',
        type: 'Service'
      },
      {
        text: 'Singapore',
        type: 'Markets'
      },
      {
        text: 'California',
        type: 'Markets'
      },

      {
        text: 'China',
        type: 'Markets'
      },
       {
        text: 'Amit Gupta',
        type: 'Service Provider'
      },
      {
        text: 'Ullrich Loeffler',
        type: 'Service Provider'
      },
      {
        text: 'Letchmy Ganapathy',
        type: 'Service Provider'
      },
      {
        text: 'Andy Young',
        type: 'Service Provider'
      },
       {
        text: 'Nandini Navale',
        type: 'Service Provider'
      },
       {
        text: 'Australia',
        type: 'Markets'
      },
      {
        text: 'India',
        type: 'Markets'
      },
      {
        text: 'New Zealand',
        type: 'Markets'
      }
    ];

    // Pagination settings
    public static paginationSettings = {
      itemsPerPage: 5,
      boundaryLinks: true,
    };

    public static selectSPPagination = {
        itemsPerPage: 10,
        boundaryLinks: true,
    };

    // User role codes
    public static userRoleCodes = {
      serviceProvider: 'tech_analyst',
      techVendor: 'tech_vendor',
      techBuyer: 'tech_buyer',
      admin: 'admin',
      visitor: 'visitor',
      analyst: 'tech_analyst'
    };

    public static projectFormLabels = {
      clientProjectbudget: 'Project Budget',
      spProjectbudget: 'Project Cost',
    };

    // Create project stepper menu list
    public static stepperMenu = [
      {
        index: 1,
        isCompleted: false,
        label: 'Create Project',
      },
      {
        index: 2,
        isCompleted: false,
        label: 'Assign Project Partner',
      },
      {
        index: 3,
        isCompleted: false,
        label: 'Launch Project',
      }
    ];
    public static stepperMenuSp = [
      {
        index: 1,
        isCompleted: false,
        label: 'Create Project',
      },
      {
        index: 2,
        isCompleted: false,
        label: 'Launch Project',
      }
    ];

    public static packageStepperMenu = [
      {
        index: 1,
        isCompleted: false,
        label: 'Create Package',
      },
      {
        index: 2,
        isCompleted: false,
        label: 'Package Summary',
      }
    ];

    // Create project stepper menu id object
    public static stepperIndex = {
      createProject: 1,
      assignPartner: 2,
      launchProject: 3
    };
    public static stepperIndexSp = {
      createProject: 1,
      launchProject: 2
    };
    public static packageStepperIndex = {
      createPackage: 1,
      launchPackage: 2
    };

    // Create project view mode
    public static createProjectViewMode = {
      stepperMode: 1,
      normalMode: 2
    };

    // ids to identify whether it is serviceline or servicetype
    public static filterTypes = {
      package: 'package',
      serviceProvider: 'tech_analyst',
    };

    public static serviceQueryTypes = {
      serviceType: 'st',
      serviceLines: 'sl',
    };

    public static maxSPLimit = 3;
    public static defaultSortType = 'sequence, price_rate desc';

    public static requestParamsConstants  = {
      serviceline: 'serviceline',
    };

    public static projectDetailsTabIds = {
      acceptedProjects: { launchproject: 'launchProject'},
      completedProjects: {projectSummary: 'projectSummary'},
      pendingProjects: { bidResponses: 'bidResponses', pendingRequests: 'pendingRequests'},
      inProgressProjects: {projectDetails: 'basicInfo', documents: 'documents', tasks: 'tasks', updates: 'updates' },
      openProjects: {bidResponses: 'bidResponses', pendingRequests: 'pendingRequests'},
    };

    public static projectDetailPageViewMode = {
      pendingProjects: 'pendingProjects',
      acceptedProjects: 'launchProject',
    };

    public static postType = {
      comment: 'comment',
      package: 'package'
    };

    public static moduleTypes = {
      package: 'package',
      report: 'report',
      socialFeeds: 'social_feed',
      upcomingReports: 'upcoming_report',
      blog: 'blog'
    };

    public static commentsFetchParams = {
      limit: 5,
    };

    public static likeCommentsLabel = {
      likes: 'likes',
      comments: 'comments',
    };

    public static itemCountUpdateMode = {
      increment: 'increment',
      decrement: 'decrement',
    };

    public static documentSortOptions =  [
      {
        name: 'Name: A-Z',
        id: 'file_name asc'
      },
      {
        name: 'Name: Z-A',
        id: 'file_name desc'
      },
    ];

    public static controlsVisibility = {
      clientBasicInfo: { showVideoChat: true, showChat: true, showEdit: true, showUpload: false, addTask: false, requestAssociate: false},
      documents: { showVideoChat: true, showChat: true, showEdit: false, showUpload: true, addTask: false, requestAssociate: false},
      tasksListing: { showVideoChat: true, showChat: true, showEdit: false, showUpload: false, addTask: true, requestAssociate: false},
      taskDetails: { showVideoChat: true, showChat: true, showEdit: false, showUpload: false, addTask: true, requestAssociate: false},
      addTask: { showVideoChat: true, showChat: true, showEdit: false, showUpload: false, addTask: false, requestAssociate: false},
      updates: { showVideoChat: true, showChat: true, showEdit: false, showUpload: false, addTask: false, requestAssociate: false},
      spBasicInfo: { showVideoChat: true, showChat: true, showEdit: false, showUpload: false, addTask: false, requestAssociate: true},
    };

    public static taskStatusList = [
      { value: 'pending', label: 'Pending'},
      { value: 'inprogress', label: 'In Progress'},
      { value: 'completed', label: 'Complete'},
     { value: 'cancelled', label: 'Cancelled'},
     { value: 'done', label: 'Done'},
    ];
    public static pendingTaskStatusList = [
      { value: 'pending', label: 'Pending'},
      { value: 'inprogress', label: 'In Progress'},
      // { value: 'completed', label: 'Completed'},
      //{ value: 'cancelled', label: 'Cancelled'},
     
      // { value: 'done', label: 'Done'},
    ];
    public static inprogressTaskStatusList = [
      { value: 'pending', label: 'Pending'},
      { value: 'inprogress', label: 'In Progress'},
       { value: 'completed', label: 'Complete'},
     // { value: 'cancelled', label: 'Cancelled'},
     
      // { value: 'done', label: 'Done'},
    ];
    public static completedTaskStatusList = [
      { value: 'pending', label: 'Pending'},
      { value: 'inprogress', label: 'In Progress'},
      { value: 'completed', label: 'Complete'},
      //{ value: 'cancelled', label: 'Cancelled'},
     
      //{ value: 'done', label: 'Done'},
    ];
    public static projectStatusList = {
      inprogress: 'inprogress',
      completed: 'completed',
      cancelled: 'cancelled',
      accepted:  'accepted'
    };

    public static projectProgressOptions = [
      { value: 'inprogress', label: 'In Progress'},
      { value: 'completed', label: 'Completed'},
      { value: 'cancelled', label: 'Cancelled'},
      { value: 'accepted', label: 'Accepted'}
    ];

    public static progressOptionsAfterInProgress = [
      { value: 'inprogress', label: 'In Progress'},
      { value: 'completed', label: 'Completed'},
      { value: 'cancelled', label: 'Cancelled'},
    ];

    public static progressStatusValues = {
      inprogress: 'inprogress',
      completed: 'completed',
      cancelled: 'cancelled',
    };

    public static progressingProjectsTabs = {
      task: {
        id: "tasks",
        url: 'tasks',
        tabName: "Tasks",
        isActive: false
      },
    };

    public static bidResponseStatus = {
      accept: 'accepted',
      reject: 'rejected',
      start: 'inprogress'
    };

    public static marketQueryType = {
      city: 'city',
      state: 'state',
      country: 'country',
    };

    public static projectTypes = {
      fixed: { id: '12378993-6482-47d1-946e-2fd201b426c4', name: 'Fixed'},
      hourly: { id: '4a33b509-1d82-43ec-96a3-7e414c155af8', name: 'Hourly'}
    };

    public static fixedProjectsDurations = {
      date: {id: 'date', label: 'Date', durationType: 'date' },
      hours: {id: 'hours', label: 'Hours', durationType: 'hours'},
      duration: {id: 'day', label: 'Duration', durationType: 'day'},
    };

    public static fixedProjectTypes = [
      { id: 'day', label: 'Duration', durationType: 'day'},
      { id: 'date', label: 'Date', durationType: 'date'},
    ];

    public static durationType = {
      date: 'date',
      days: 'day',
      hours: 'hours',
    };

    public static noDataText = {
      projectForm: 'Not Specified',
    };

    public static userCurrency = {
      dollar: '$'
    };

    public static chatMessageType = {
      text: 'text',
      json: 'json'
    };

    // File size limit in bytes
    public static maxFileSize = {
      doc: '50485760',
    };

    // File upload doctypes
    public static docTypes = {
      profilePic: 'profilePic',
      projectDocument: 'projectDocument',
      commentDoc: 'commentDocument',
      report: 'report',
      aboutUs: 'aboutUs',
      howItWorks: 'howItWorks',
      language: 'language',
      countryFlag: 'countryFlag',
      serviceType: 'serviceType',
      images: { banner: 'banner', logo: 'logo'},
    };

    public static fileSourceInfo = {
      project: 'project',
      taskComment: 'taskComment',
    };

    public static noDataMsg = {
      noBid: 'No Bids Found',
      noProject: 'No Projects Found'
    };

  }



// WEBPACK FOOTER //
// ./src/app/util/app-constants.ts